import { createSlice } from "@reduxjs/toolkit";
import {
  setOutboundCallerId,
  getCallEndedStatus,
} from "../services/outboundCall";

interface OutboundCallState {
  outboundPhoneCallStatus: string;
  showLoadingIndicator: boolean;
  outboundPhoneCallerId: string | null;
  isCallEnded: boolean;
}

const initialState: OutboundCallState = {
  outboundPhoneCallStatus: "idle",
  showLoadingIndicator: false,
  outboundPhoneCallerId: null,
  isCallEnded: false,
};

const outboundCallSlice = createSlice({
  name: "outboundCall",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setOutboundCallerId.pending, (state) => {
        state.outboundPhoneCallStatus = "pending";
        state.showLoadingIndicator = true;
        state.isCallEnded = false;
        state.outboundPhoneCallerId = null;
      })
      .addCase(setOutboundCallerId.fulfilled, (state, action) => {
        state.outboundPhoneCallStatus = "success";
        state.showLoadingIndicator = false;
        state.isCallEnded = false;
        state.outboundPhoneCallerId = action.payload as string | null;
      })
      .addCase(setOutboundCallerId.rejected, (state) => {
        state.outboundPhoneCallStatus = "rejected";
        state.showLoadingIndicator = false;
        state.isCallEnded = false;
        state.outboundPhoneCallerId = null;
      })
      .addCase(getCallEndedStatus, (state) => {
        state.isCallEnded = true;
      });
  },
});

export default outboundCallSlice.reducer;
